var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('y_editor',{model:{value:(_vm.form.detail),callback:function ($$v) {_vm.$set(_vm.form, "detail", $$v)},expression:"form.detail"}}),_c('div',{staticStyle:{"margin-top":"1rem"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('form-submit')}}},[_vm._v("提交")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }